import { render, staticRenderFns } from "./svg.vue?vue&type=template&id=0cc89c4d&scoped=true"
import script from "./svg.vue?vue&type=script&lang=js"
export * from "./svg.vue?vue&type=script&lang=js"
import style0 from "./svg.vue?vue&type=style&index=0&id=0cc89c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_v5mjhuasro5cnca5bddsdhezz4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc89c4d",
  null
  
)

export default component.exports